import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import Navbar from '../components/Navbar';


const CartPage = () => {
  const { cart, totalAmount } = useContext(AppContext);
  const canCheckout = totalAmount >= 2000;

  // Flexible Backend Host Handling Configuration
  const API_URL = window.location.hostname === 'localhost' ? 'https://ak-carckers-backend-api.onrender.com' : '';

  // Handle completely empty cart scenario cleanly
  if (cart.length === 0) {
    return (
      <div className="page-shell">
        <Navbar />
        <main className="container py-5 text-center">
          <div className="card shadow-sm p-5 border-0 rounded-3">
            <h2 className="h4 fw-bold text-muted mb-3">Your shopping cart is completely empty!</h2>
            <p className="mb-4 text-secondary">Add some amazing crackers to light up your celebrations.</p>
            <Link to="/products" className="btn btn-danger btn-lg px-4 fw-bold shadow-sm">Go To Shop</Link>
          </div>
        </main>
  
      </div>
    );
  }

  if (!canCheckout) {
    return (
      <div className="page-shell">
        <Navbar />
        <main className="container py-4">
          <div className="alert alert-warning border-0 shadow-sm fw-bold">
            🚚 Door Delivery Available Only For Orders Above ₹2000. Add ₹{2000 - totalAmount} more to continue.
          </div>
          <div className="card shadow-sm p-4 text-center border-0">
            <h2 className="h5 fw-bold text-muted">Your cart total is below the minimum order value.</h2>
            <p className="mb-3">Please continue shopping and add more products.</p>
            <Link to="/products" className="btn btn-danger px-4 py-2 fw-bold shadow-sm">Continue Shopping</Link>
          </div>
        </main>
       
      </div>
    );
  }

  return (
    <div className="page-shell">
      <Navbar />
      <main className="container py-4">
        <h1 className="h3 mb-3 fw-bold text-danger">Your Shopping Cart</h1>
        <div className="table-responsive mb-4 shadow-sm rounded-3 border">
          <table className="table table-hover align-middle mb-0 text-center">
            <thead className="table-dark text-uppercase small">
              <tr>
                <th>Image</th>
                <th className="text-start">Product</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Sub Total</th>
              </tr>
            </thead>
            <tbody>
              {cart.map(item => (
                <tr key={item.productId}>
                  <td className="ak-product-image" style={{ width: '100px' }}>
                    {/* FIXED: Added API_URL base and responsive sizing inline bounds */}
                    <img 
                      src={`${API_URL}${item.imageUrl}`} 
                      alt={item.name} 
                      className="rounded" 
                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                      onError={(e) => {
                        // Fallback handling in case of absolute local image system path dropouts
                        e.target.onerror = null; 
                        e.target.src = 'https://placehold.co/60x60?text=Crackers';
                      }}
                    />
                  </td>
                  <td className="text-start text-muted">{item.name}</td>
                  <td>
                    <span className="badge bg-secondary fs-6 px-3">{item.quantity}</span>
                  </td>
                  <td className="text-muted">₹{item.offerPrice}</td>
                  <td className="fw-bold text-danger">₹{item.subtotal}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="card shadow-sm p-4 border-0 rounded-3">
          <h2 className="h5 fw-bold text-muted mb-1">Grand Total</h2>
          <p className="display-6 fw-bold text-danger mb-4">₹{totalAmount}</p>
          <div className="d-flex flex-column flex-md-row gap-3">
            <Link to="/products" className="btn btn-outline-secondary btn-lg px-4 fw-bold">Continue Shopping</Link>
            <Link to="/checkout" className="btn btn-danger btn-lg px-5 fw-bold shadow">Buy Now</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CartPage;